export default {"src":"/_next/static/media/Airdrop.f6c85834.svg","height":91,"width":91};